import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModuloResponse } from '../../../_infrastructure/dtos/core/modulo/ModuloResponse';
import { UnsubscribeOnDestroyAdapter } from '../../../_shared';
import { Router } from '@angular/router';
import { ModuloCategoriaGroup } from '../../../_infrastructure/dtos/core/modulo/ModuloCategoriaGroup';
import { ClienteResponse } from '../../../_infrastructure/dtos/core/cliente/ClienteResponse';
import { ModuloContextService } from '../../../_infrastructure/context-service/modulo/modulo-context.service';
import { ClienteContextService } from '../../../_infrastructure/context-service/cliente/cliente-context.service';
import { ModuloNavigationService } from '../../../_shared/utils/ModuloNavigationService';
import { combineLatest } from 'rxjs';
import { DomainService } from '../../../_infrastructure/services/domain/domain.service';

@Component({
  selector: 'app-transparencia-header',
  templateUrl: './transparencia-header.component.html',
  styleUrls: ['./transparencia-header.component.css'],
  standalone: false
})
export class TransparenciaHeaderComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  modulos: ModuloResponse[] = [];
  categorias: ModuloCategoriaGroup[] = [];
  menuAberto = false;
  cliente!: ClienteResponse;
  totalModulos = 0;

  constructor(
    private readonly moduloContext: ModuloContextService,
    private readonly clienteContext: ClienteContextService,
    private readonly router: Router,
    private readonly moduloNav: ModuloNavigationService,
    private readonly cdr: ChangeDetectorRef,
    public readonly domainService: DomainService
  ) { super(); }

  ngOnInit(): void {
    this.subs.sink = combineLatest([
      this.moduloContext.getModulos(),
      this.clienteContext.getCliente()
    ]).subscribe(([modulos, cliente]) => {
      this.cliente = cliente;
      this.modulos = modulos.filter(x => x.exibirModuloPortalTransparenciaLateral);

      this.modulos = modulos.filter(m =>
        !cliente.clienteModulos?.some(
          cm => cm.moduloId === m.id && cm.ocultarLateral
        )
      );
      this.categorias = this.agruparPorCategoria(this.modulos);
      this.totalModulos = this.categorias
        .reduce((total, categoria) => total + categoria.modulos.length, 0);
      this.cdr.detectChanges();
    });
  }

  toggleMenu() {
    this.menuAberto = !this.menuAberto;
  }

  private agruparPorCategoria(modulos: ModuloResponse[]): ModuloCategoriaGroup[] {
    const map = new Map<string, ModuloCategoriaGroup>();

    modulos.forEach(modulo => {
      const categoriaId = modulo.moduloCategoria?.id ?? 'sem-categoria';
      const categoriaNome = modulo.moduloCategoria?.nome ?? 'Outros';

      if (!map.has(categoriaId)) {
        map.set(categoriaId, {
          categoriaId,
          categoriaNome,
          modulos: []
        });
      }

      map.get(categoriaId)!.modulos.push(modulo);
    });

    return Array.from(map.values())
      .filter(c => c.modulos.length > 0)
      .sort((a, b) => a.categoriaNome.localeCompare(b.categoriaNome));
  }

  navegar(modulo: ModuloResponse) {
    const url = this.moduloNav.resolveUrl(modulo, this.cliente);

    if (this.moduloNav.isExternal(url)) {
      window.open(url, '_blank');
      return;
    }

    this.router.navigate(url.split('/'));
  }

  isAtivo(modulo: ModuloResponse): boolean {
    const url = this.moduloNav.resolveUrl(modulo, this.cliente);

    if (this.moduloNav.isExternal(url)) {
      return false;
    }

    return this.router.url === `/${url}`;
  }

}